import React, { useEffect, useRef } from 'react';

import { useClickAwayClose } from  '@/components/hooks/utility/useClickAwayClose';


interface IFixedPositionTooltip {
    contents:JSX.Element, 
    closeOnScrollTarget?:string, 
    containerQuerySelector?: string, 
    controlIsOpen: boolean,
    setControlIsOpen: (val: boolean) => void,
    className?:string
    manualOffset: {top?:number, right?:number}
    parentRef?: React.RefObject<HTMLElement>
}



const FixedPositionTooltip = ({contents, closeOnScrollTarget, containerQuerySelector, controlIsOpen, className, setControlIsOpen, manualOffset, parentRef}: IFixedPositionTooltip) => {
    const containerRef = useRef<HTMLDivElement>();
    const modalRect = containerQuerySelector 
        ? document.querySelector(containerQuerySelector).getBoundingClientRect()
        : document.body.getBoundingClientRect()
    let {top } = containerRef.current  ? containerRef.current.getBoundingClientRect() : {top: 0}

    
    useClickAwayClose(controlIsOpen, parentRef || containerRef, closeMenu)

    useEffect(() => {
        closeOnScrollTarget && document.querySelector(closeOnScrollTarget).addEventListener('scroll', closeMenu);
            
        return () => {
            closeOnScrollTarget && document?.querySelector(closeOnScrollTarget)?.removeEventListener('scroll', closeMenu);

        };
    },[])

    function closeMenu() {
        setControlIsOpen(false);
    }

    function getTop(){
        return top - (manualOffset?.top || 0 )
    }
    
    return (
       
            <div className={`fixed-position-tooltip-wrapper ${className}`} ref={containerRef}>
                {controlIsOpen && <div className='fixed-position-tooltip' style={{top: getTop(), position:'fixed', right: manualOffset?.right + modalRect.left || 0}}>
                    {contents}
                   
                </div>}
            </div>
        
    )
}

export default FixedPositionTooltip 